/**
 * Samedi Hero Banner JavaScript
 * Extracted from samedi-home-hero-banner.liquid
 * Uses shared utilities from theme-utilities.js
 */

(function() {
  'use strict';

  // Require SamediUtils
  if (typeof window.SamediUtils === 'undefined') {
    console.error('SamediUtils not loaded - hero banner may not work correctly');
    return;
  }

  let lastScrollTop = 0;
  let ticking = false;
  let fadeTicking = false;

  const elements = {
    selector: document.querySelector('.audience-selector'),
    buttons: document.querySelectorAll('.audience-btn'),
    heroSections: document.querySelectorAll('.hero-section')
  };

  /**
   * Show specific audience hero section
   * @param {string} audience - 'women' or 'men'
   */
  function showAudience(audience) {
    elements.heroSections.forEach(section => {
      section.classList.remove('hero-section--active');
    });

    const heroSection = document.getElementById(audience + '-hero');
    if (heroSection) {
      heroSection.classList.add('hero-section--active');
    }

    elements.buttons.forEach(btn => {
      btn.classList.remove('active');
      if (btn.dataset.audience === audience) {
        btn.classList.add('active');
      }
    });

    // Switch dynamic subtitle
    const subtitle = document.querySelector('.hero-dynamic-subtitle');
    if (subtitle) {
      const subtitleText = subtitle.getAttribute('data-' + audience + '-text');
      if (subtitleText) {
        subtitle.textContent = subtitleText;
      }
    }

    // Use shared utility to set audience
    window.SamediUtils.setAudience(audience);
  }

  /**
   * Handle scroll to show/hide audience selector
   */
  function handleScroll() {
    const currentScroll = window.pageYOffset || document.documentElement.scrollTop;

    if (!elements.selector) return;

    if (currentScroll > lastScrollTop && currentScroll > 100) {
      elements.selector.classList.add('hide');
    } else if (currentScroll < lastScrollTop) {
      elements.selector.classList.remove('hide');
    }

    lastScrollTop = currentScroll <= 0 ? 0 : currentScroll;
    ticking = false;
  }

  /**
   * Apply fade effect to hero content on scroll
   */
  function applyContentFade() {
    const scrolled = window.pageYOffset;
    const heroContent = document.querySelector('.hero-section--active .hero-content');

    if (heroContent) {
      if (scrolled < 500) {
        const opacity = Math.max(0, 1 - (scrolled / 500));
        heroContent.style.opacity = opacity;
      } else {
        heroContent.style.opacity = 0;
      }
    }

    fadeTicking = false;
  }

  /**
   * Remove will-change after animations complete
   */
  function cleanupAnimations() {
    setTimeout(() => {
      const animatedElements = document.querySelectorAll('.hero-headline, .headline-line-1, .headline-line-2, .hero-subtitle, .hero-cta, .discount-notice');
      animatedElements.forEach(el => {
        el.classList.add('animation-complete');
      });
    }, 2000); // After all animations complete
  }

  /**
   * Initialize hero banner
   */
  function init() {
    // Button click handlers
    elements.buttons.forEach(btn => {
      btn.addEventListener('click', function() {
        showAudience(this.dataset.audience);
      });
    });

    // Scroll handlers with throttling
    window.addEventListener('scroll', function() {
      if (!ticking) {
        requestAnimationFrame(handleScroll);
        ticking = true;
      }

      if (!fadeTicking) {
        requestAnimationFrame(applyContentFade);
        fadeTicking = true;
      }
    }, { passive: true });

    // Initialize with saved audience
    const savedAudience = window.SamediUtils.getCurrentAudience();
    showAudience(savedAudience);

    // Clean up animations after they complete
    cleanupAnimations();

    // Listen for audience changes from other sections
    window.SamediUtils.onAudienceChange(function(newAudience) {
      showAudience(newAudience);
    });
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
